module.exports = __webpack_public_path__ + "./images/edd7fd4ede63a7feefe4d109d5072b7b.webp";